export default "__VITE_ASSET__RcugQK8N__"